<template>

    <div>
        <section class="dashboard-area">
            <div class="dashboard_menu_area" v-if="userId && currentUserData && userId === currentUserData.id">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                            <ul class="dashboard_menu">
                                <li :class="{active: stateCurrentComponent === 'profile-component' || stateCurrentComponent === 'volunteer-backend-profile-component'}">
                                    <a class="cursor-pointer" @click="redirect('profile-component')">
                                        <span class="icon icon-profile"></span>
                                        {{$store.getters.t('main_menu_profile')}}
                                    </a>
                                </li>
                                <li :class="{active: stateCurrentComponent === 'dashboard-component'}">
                                    <a class="cursor-pointer" @click="redirect('dashboard-component')">
                                        <span class="icon icon-dashboard"></span>
                                        {{$store.getters.t('main_menu_dashboard')}}
                                    </a>
                                </li>
                                <li :class="{active: stateCurrentComponent === 'notification-component' || stateCurrentComponent === 'volunteer-backend-notification-component'}">
                                    <a class="cursor-pointer" @click="redirect('notification-component')">
                                        <span class="icon icon-notice"></span>
                                        {{$store.getters.t('main_menu_notifications')}}
                                    </a>
                                </li>
                                <li :class="{active: stateCurrentComponent === 'settings-component' || stateCurrentComponent === 'volunteer-backend-settings-component'}">
                                    <a class="cursor-pointer" @click="redirect('settings-component')">
                                        <span class="icon icon-setting"></span>
                                        {{$store.getters.t('main_menu_profile_settings')}}
                                    </a>
                                </li>

                                <li :class="{active: stateCurrentComponent === 'pets-component' || stateCurrentComponent === 'volunteer-backend-pets-component'}">
                                    <a class="cursor-pointer" @click="redirect('pets-component')">
                                        <span class="icon icon-less"></span>
                                        {{$store.getters.t('main_menu_my_wards')}}
                                    </a>
                                </li>

                                <li :class="{active: stateCurrentComponent === 'finances-component'}">
                                    <a class="cursor-pointer" :href="`/volunteer/${currentUserData.id}/finance-report`" @click="setComponent('finances-component')">
                                        <span class="icon icon-transaction"></span>
                                        {{$store.getters.t('main_menu_transactions')}}
                                    </a>
                                </li>
                            </ul>
                            <!-- end /.dashboard_menu -->
                        </div>
                        <!-- end /.col-md-12 -->
                    </div>
                    <!-- end /.row -->
                </div>
                <!-- end /.container -->
            </div>

        </section>
    </div>


</template>

<script>

import {mapGetters, mapMutations} from 'vuex';

export default {
    data() {
        return {
            appRoutes: null,
        }
    },
    props: ['userId', 'component'],
    created(){
        this.appRoutes = window.appRoutes;

    },
    mounted(){},

    computed: {

        ...mapGetters({
            stateCurrentComponent: 'getterProfileTab',
            stateProfileType: 'getUserProfileType'
        }),

        currentUserData() {
            return this.$store.getters.getUserData;
        },


    },

    methods: {
        ...mapMutations({
            setComponent: 'setterProfileTab',
            setProfileType: 'setUserProfileType'
        }),

        async redirect(component){

            if(window.location.href.indexOf(`/user/${this.currentUserData.id}/profile`) === -1){
                window.location.href = await ( window.location.origin + `/user/${this.currentUserData.id}/profile` )
            }

            await this.setComponent(component)

        },

    },
    watch: {

        currentUserData(){

            if( this.currentUserData  &&  ( +this.currentUserData.id  ===  +this.userId ) ){

                if( this.stateProfileType  !== 'zooprotection' ) this.setProfileType('zooprotection')

                this.setComponent(this.component)

            }

        },

    }
}
</script>

<style lang="scss" scoped>

.component-fade-enter-active, .component-fade-leave-active {
    transition: opacity .3s ease;
}
.component-fade-enter, .component-fade-leave-to
    /* .component-fade-leave-active до версии 2.1.8 */
{
    opacity: 0;
}
</style>
